import { render, staticRenderFns } from "./nbhot.vue?vue&type=template&id=7e97c6f4&"
import script from "./nbhot.vue?vue&type=script&lang=js&"
export * from "./nbhot.vue?vue&type=script&lang=js&"
import style0 from "./nbhot.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports